 <template>
<div class="p-grid p-fluid dashboard">
	<div class="p-col-12 ">
		<div class="card docs">
			<Panel header="BIENVENIDO AL SISTEMA" style="height: 100%;">
				<center>
			<br><br><br><img src="assets/layout/images/logoSIACV.png"/><br><br><br>
				</center>
			</Panel>
		</div>
	</div>
	


</div>
</template>

<script>
export default {
	
}
</script>

<style lang="scss" scoped>
	@media screen and (max-width: 960px) {
		::v-deep(.p-datatable) {
			&.p-datatable-customers {
				.p-datatable-thead > tr > th,
				.p-datatable-tfoot > tr > td {
					display: none !important;
				}

				.p-datatable-tbody > tr {
					border-bottom: 1px solid #dee2e6;
					> td {
						text-align: left;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 0 none !important;
						width: 100% !important;
						float: left;
						clear: left;
						border: 0 none;

						.p-column-title {
							padding: .4rem;
							min-width: 30%;
							display: inline-block;
							margin: -.4rem 1rem -.4rem -.4rem;
							font-weight: bold;
						}

						.p-progressbar {
							margin-top: .5rem;
						}
					}
				}
			}
		}
	}
</style>
